import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Spinner from "../../ui/spinner/Spinner";
import LoginContext from "../../../store/login/LoginContext";
import styles from "./OptionsStyles.module.css";
import { isValidName, formatName } from "../../../auth/userCredentialsUtils";

const ProfileUpdate = (props) => {
  const loginCtx = useContext(LoginContext);

  const [showSpinner, setShowSpinner] = useState(false);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [callname, setCallname] = useState("");

  const [editFirstname, setEditFirstname] = useState(false);
  const [editLastname, setEditLastname] = useState(false);
  const [editCallname, setEditCallname] = useState(false);

  const [firstnameError, setFirstnameError] = useState("");
  const [lastnameError, setLastnameError] = useState("");
  const [callnameError, setCallnameError] = useState("");
  const [serverError, setServerError] = useState("");

  const clearErrors = () => {
    setFirstnameError("");
    setLastnameError("");
    setCallnameError("");
    setServerError("");
  };

  const fetchInitialValues = async () => {
    try {
      setShowSpinner(true);

      const response = await axios.post(
        "php/sign_in/get_user_data.php",
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("RAW RESPONSE", response);
      const data = response.data;
      console.log("DATA", data);

      if (data.code !== 200) {
        alert(
          data.message ||
            "The server may not be available. Please check your internet connection",
        );

        setServerError(response.data?.message || "Failed to load user data.");
        return;
      }
      const profileData = data.profileData;
      setFirstname(profileData.firstname || "");
      setLastname(profileData.lastname || "");
      setCallname(profileData.callname || "");
      
    } catch (error) {
      const data = error?.response?.data;
      setServerError(
        data?.message || "Error connecting to server. Please retry.",
      );

    } finally {
      setShowSpinner(false);
    }
  };

  useEffect(() => {
    fetchInitialValues();
  }, []);

  const validateInputs = () => {
    let isValid = true;

    if (!isValidName(firstname)) {
      setFirstnameError("Your firstname is invalid.");
      isValid = false;
    }

    if (!isValidName(lastname)) {
      setLastnameError("Your lastname is invalid.");
      isValid = false;
    }

    if (!isValidName(callname)) {
      setCallnameError("Your callname is invalid.");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    clearErrors();

    if (!firstname || !lastname || !callname) {
      setServerError("Please fill all fields correctly.");
      return;
    }

    if (!validateInputs()) return;

    const payload = {
      firstname: formatName(firstname),
      lastname: formatName(lastname),
      callname: formatName(callname),
    };

    try {
      setShowSpinner(true);

      const response = await axios.post(
        "php/sign_in/update_user_data.php",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);
      console.log("DATA MESSAGE", response.data);

      if (response.data.code === 200) {
        if (loginCtx.callname !== payload.callname) {
          loginCtx.callname = payload.callname;
        }

        alert(response.data.message || "Profile updated successfully.");
        props.onCompletion();
        return;
      }

      setServerError(response.data?.message || "Failed to update profile.");

    } catch (error) {
      const data = error?.response?.data;

      alert(data?.message || "Error connecting to server. Please retry.");
      setServerError(
        data?.message || "Error connecting to server. Please retry.",
      );
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Update your profile</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="firstname">Firstname</label>
        <div>
          <input
            id="firstname"
            maxLength={30}
            required
            autoComplete="off"
            value={firstname}
            onChange={(e) => {
              setFirstname(e.target.value);
              setFirstnameError("");
              setServerError("");
            }}
          />
        </div>
      </div>
      {firstnameError && (
        <span className={styles.errorText}>{firstnameError}</span>
      )}

      <div className={styles.inputView}>
        <label htmlFor="lastname">Lastname</label>
        <div>
          <input
            id="lastname"
            maxLength={30}
            required
            autoComplete="off"
            value={lastname}
            onChange={(e) => {
              setLastname(e.target.value);
              setLastnameError("");
              setServerError("");
            }}
          />
        </div>
        {lastnameError && (
          <span className={styles.errorText}>{lastnameError}</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="callname">Callname</label>
        <div>
          <input
            id="callname"
            maxLength={30}
            required
            autoComplete="off"
            value={callname}
            onChange={(e) => {
              setCallname(e.target.value);
              setCallnameError("");
              setServerError("");
            }}
          />          
        </div>
        {callnameError && (
          <span className={styles.errorText}>{callnameError}</span>
        )}
      </div>

      {serverError && <p className={styles.errorText}>{serverError}</p>}

      <div className={styles.btnDiv}>
        <button
          type="button"
          className={styles.bgGreen}
          onClick={handleSubmit}
          disabled={showSpinner}
        >
          Submit
        </button>
        <button
          type="button"
          className={styles.bgRed}
          onClick={props.onCancel}
          disabled={showSpinner}
        >
          Cancel
        </button>
      </div>

      {showSpinner && <Spinner />}
    </div>
  );
};

export default ProfileUpdate;

/*
<div className={styles.inputView}>
  <label htmlFor="firstname">Firstname</label>
  <div>
    <input
      id="firstname"
      maxLength={30}
      required
      autoComplete="off"
      value={firstname}
      disabled={!editFirstname}
      onChange={(e) => {
        setFirstname(e.target.value);
        setFirstnameError("");
        setServerError("");
      }}
    />
    <button
      type="button"
      className={styles.editBtn}
      onClick={() => setEditFirstname(true)}
    >
      Edit
    </button>
  </div>
</div>
{firstnameError && (
  <span className={styles.errorText}>{firstnameError}</span>
)}

<div className={styles.inputView}>
  <label htmlFor="lastname">Lastname</label>
  <div>
    <input
      id="lastname"
      maxLength={30}
      required
      autoComplete="off"
      value={lastname}
      disabled={!editLastname}
      onChange={(e) => {
        setLastname(e.target.value);
        setLastnameError("");
        setServerError("");
      }}
    />
    <button
      type="button"
      className={styles.editBtn}
      onClick={() => setEditLastname(true)}
    >
      Edit
    </button>
  </div>
  {lastnameError && (
    <span className={styles.errorText}>{lastnameError}</span>
  )}
</div>

<div className={styles.inputView}>
  <label htmlFor="callname">Callname</label>
  <div>
    <input
      id="callname"
      maxLength={30}
      required
      autoComplete="off"
      value={callname}
      disabled={!editCallname}
      onChange={(e) => {
        setCallname(e.target.value);
        setCallnameError("");
        setServerError("");
      }}
    />
    <button
      type="button"
      className={styles.editBtn}
      onClick={() => setEditCallname(true)}
    >
      Edit
    </button>
  </div>
  {callnameError && (
    <span className={styles.errorText}>{callnameError}</span>
  )}
</div>
*/